<template>
  <div>
    <ContentWrap title="转播订单">
      <el-form :inline="true" class="mb8" @submit.prevent>
        <el-form-item label="直播间">
          <LiveRoomIdSelect v-model="queryParams.liveId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item label="买家用户">
          <LiveMemberUserSelect v-model="queryParams.buyerUserId" select-class="!w-260px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery"><Icon icon="ep:search" />查询</el-button>
          <el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button>
        </el-form-item>
      </el-form>
    </ContentWrap>

    <ContentWrap>
      <el-table v-loading="loading" :data="list" border>
        <el-table-column label="编号" prop="id" width="80" />
        <el-table-column label="转播商品ID" prop="relayId" min-width="120" />
        <el-table-column label="直播ID" prop="liveId" min-width="100" />
        <el-table-column label="买家用户ID" prop="buyerUserId" min-width="120" />
        <el-table-column label="商家用户ID" prop="sellerUserId" min-width="120" />
        <el-table-column label="价格（元）" width="120"
          ><template #default="{ row }">{{
            (Number(row.price || 0) / 100).toFixed(2)
          }}</template></el-table-column
        >
        <el-table-column label="支付状态" prop="payStatus" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.payStatus === 1 ? 'success' : 'warning'">{{
              scope.row.payStatus === 1 ? '已付' : scope.row.payStatus === 2 ? '已撤销' : '待付款'
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="统一订单ID" prop="tradeOrderId" min-width="120" />
        <el-table-column label="支付单ID" prop="payOrderId" min-width="120" />
        <el-table-column label="转播直播间" prop="relayLiveId" min-width="120" />
        <el-table-column label="支付渠道" prop="payChannel" min-width="120" />
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="180"
          :formatter="dateFormatter"
        />
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        v-model:page="queryParams.pageNo"
        v-model:limit="queryParams.pageSize"
        @pagination="getList"
      />
    </ContentWrap>
  </div>
</template>

<script setup lang="ts">
import { pageRelayOrder } from '@/api/live/relayOrder'
import { dateFormatter } from '@/utils/formatTime'
import LiveRoomIdSelect from '@/views/live/components/LiveRoomIdSelect.vue'
import LiveMemberUserSelect from '@/views/live/components/LiveMemberUserSelect.vue'

const list = ref<any[]>([])
const total = ref(0)
const loading = ref(false)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  liveId: undefined as number | undefined,
  buyerUserId: undefined as number | undefined
})

async function getList() {
  loading.value = true
  try {
    const result: any = await pageRelayOrder(queryParams)
    list.value = result.list || []
    total.value = result.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryParams.liveId = undefined
  queryParams.buyerUserId = undefined
  handleQuery()
}

onMounted(getList)
</script>
